<template>
  <!-- Kontener widoku zakresowego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: nazwa pola przetłumaczona przez $t -->
    <div class="name">{{ $t(name) }}</div>
    <!-- Symbol 'od': klasa symbol lub symbol2 dla prędkości -->
    <span
      :class="name === 'Prędkość [km/h]' ? 'symbol2' : 'symbol'"
    >
      {{ t('from').toLowerCase() }}
    </span>
    <!-- Pole pokazujące wartość minimalną (od):
         - atrybut name odpowiada key w store.filters
         - wartość pobierana z store i wyświetlana, input jest tylko do odczytu
         - blokujemy zmianę przez scroll, touchmove i scroll -->
    <input
      :name="fieldFromName"
      :value="filtersStore.filters[fieldFromName]"
      disabled
      type="text"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol 'do': podobnie jak powyżej -->
    <span
      :class="name === 'Prędkość [km/h]' ? 'symbol2' : 'symbol'"
    >
      {{ t('to').toLowerCase() }}
    </span>
    <!-- Pole pokazujące wartość maksymalną (do) -->
    <input
      :name="fieldToName"
      :value="filtersStore.filters[fieldToName]"
      disabled
      type="text"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
  </div>
</template>

<script>
import { useCurrentFiltersStore } from "../../stores/currentFilters"; // Import store z aktualnymi filtrami

export default {
  name: "RangeFilterView", // Nazwa komponentu
  props: ["name", "typeName"], // Props: tekst etykiety i typ filtra (minX/maxX)
  setup(props) {
    // Inicjalizacja store Pinia
    const filtersStore = useCurrentFiltersStore();
    // Wyodrębnienie nazwy pola (bez prefixu min/max)
    const type = props.typeName.slice(3);
    // Klucze w store dla wartości od i do
    const fieldFromName = "min" + type;
    const fieldToName = "max" + type;

    // Zwracamy dane do użycia w template
    return { fieldFromName, fieldToName, filtersStore };
  },
};
</script>

<style scoped>
/* Styl etykiety nazwy filtra */
.name {
  width: 80px;          /* Szerokość kolumny z nazwą */
  padding: 5px 0;       /* Padding w pionie */
  margin: 5px 5px 5px 0; /* Margines wokół nazwy */
}

/* Symbol operatora: standardowy i dla prędkości większy padding */
.symbol {
  padding: 10px 5px 0 5px;
}
.symbol2 {
  padding: 20px 5px 0 5px;
}

/* Styl pola input do wyświetlania wartości */
input {
  width: 45px;         /* Szerokość pola */
  text-align: center;  /* Wyśrodkowanie tekstu */
  padding: 0;          /* Brak paddingu */
  margin: 5px 0;       /* Margines pionowy */
}
</style>